// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { linkIconStyleGenerator } from "@bg/App/SharedStyles/GeneralStyles";
import onePageCheckoutPageLayoutSharedStyles from "@bg/App/SharedStyles/OnePageCheckout/OnePageCheckoutPageLayoutSharedStyles";
import { containerStyles } from "@bg/Overrides/Widgets/OnePageCheckoutConfirmation/OnePageCheckoutConfirmationPageContainer";
import { mergeWithCss } from "@bg/XDL/Utilities/mergeWithCss";
import xScreen from "@bg/XDL/Utilities/xScreen";
import { css } from "styled-components";

containerStyles.wrapper = {
    css: css`
        position: relative;
    `,
};

containerStyles.container = {
    ...onePageCheckoutPageLayoutSharedStyles.container,
};

containerStyles.printLink = {
    ...linkIconStyleGenerator({
        icon: "Print",
        textSize: "13px",
        iconSize: 20,
    }),
    css: css`
        position: absolute;
        right: 0;
        top: -50px;

        ${xScreen("lte", "xs")} {
            position: relative;
            top: unset;
            margin-bottom: 10px;
        }
    `,
};

containerStyles.title = {
    ...onePageCheckoutPageLayoutSharedStyles.title,
};

containerStyles.leftSection = {
    ...mergeWithCss(onePageCheckoutPageLayoutSharedStyles.leftSection, {
        css: css`
            ${xScreen("lte", "xs")} {
                order: 2;
            }
        `,
    }),
};

containerStyles.rightSection = {
    ...mergeWithCss(onePageCheckoutPageLayoutSharedStyles.rightSection, {
        css: css`
            ${xScreen("lte", "xs")} {
                order: 1;
            }
            @media print {
                margin-top: 32px;
            }
        `,
    }),
};

containerStyles.headerContainer = {
    ...onePageCheckoutPageLayoutSharedStyles.infoSection,
};

containerStyles.addressesContainer = {
    ...onePageCheckoutPageLayoutSharedStyles.infoSection,
};

containerStyles.paymentContainer = {
    ...onePageCheckoutPageLayoutSharedStyles.infoSection,
};

containerStyles.shippingContainer = {
    ...onePageCheckoutPageLayoutSharedStyles.infoSection,
};

containerStyles.productsContainer = {
    ...mergeWithCss(onePageCheckoutPageLayoutSharedStyles.productsContainer, {
        css: css`
            ${xScreen("lte", "md")} {
                display: none;
            }
        `,
    }),
};

containerStyles.productsContainerTablet = {
    ...mergeWithCss(onePageCheckoutPageLayoutSharedStyles.productsContainer, {
        css: css`
            display: none;
            ${xScreen("lte", "md")} {
                display: block;
                grid-column: 1/3;
            }
            ${xScreen("lte", "xs")} {
                grid-column: initial;
                padding-top: 0;
                order: 3;
            }
        `,
    }),
};
